<template>
  <svg
    :width="size * (13 / 12)"
    :height="size"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g :clip-path="`url(#clip0_5694_68586)`">
      <path
        d="M11.375 6.75V10.5C11.375 11.3273 10.7023 12 9.875 12H2.375C1.54648 12 0.875 11.3283 0.875 10.5211V6.77109C0.875 5.94258 1.54648 5.27109 2.375 5.27109L2.75 5.25V3.375C2.75 1.51383 4.26406 0 6.125 0C7.98594 0 9.5 1.51383 9.5 3.375V3.75H8V3.375C8 2.34094 7.15859 1.5 6.125 1.5C5.09141 1.5 4.25 2.34094 4.25 3.375V5.25H9.875C10.7023 5.25 11.375 5.92266 11.375 6.75Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_5694_68586">
        <rect :width="size - 1" :height="size" fill="white" transform="translate(0.125)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#242424',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
